import AppConstants from '../constants/AppConstants';

export const initialState = {
    loading: false,
    error: null,
    store: {
        dataTable: {
            version: 3
        },
        report: {}
    }
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.SERVER_STORAGE_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.SERVER_STORAGE_SUCCESS:
            let store = {
                ...state.store,
                ...action.items
            };

            return {
                ...state,
                loading: false,
                error: null,
                store: dataFormatting(store)
            };

        case AppConstants.SERVER_STORAGE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
};

const dataFormatting = (store) => {
    let newStore = {};

    for (let key in initialState.store) {
        newStore[key] = store[key];
    }

    return newStore;
};
